import { HTTPRequestType } from '../api.types';
import { rootApi } from '../rootApi';

/** The org's ordered candidate summary-line field keys (spec item 17, JT1-1538). */
export interface CandidateSummaryFieldsResponse {
  fields: string[];
}

/**
 * Org-level candidate summary-line fields (JT1-1538). Self-scoped under /organizations/my so any user
 * reads their own org's config to render the summary line; the write is org-admin gated server-side.
 * Mirrors the account-scope column-preferences service (JT1-1528).
 */
const candidateSummaryFieldsService = rootApi.injectEndpoints({
  endpoints: (builder) => ({
    getCandidateSummaryFields: builder.query<CandidateSummaryFieldsResponse, void>({
      query: () => ({ url: '/organizations/my/candidate-summary-fields' }),
      providesTags: ['CandidateSummaryFields'],
    }),

    updateCandidateSummaryFields: builder.mutation<CandidateSummaryFieldsResponse, { fields: string[] }>({
      query: (data) => ({
        url: '/organizations/my/candidate-summary-fields',
        method: HTTPRequestType.PUT,
        data,
      }),
      invalidatesTags: ['CandidateSummaryFields'],
    }),
  }),
});

export const { useGetCandidateSummaryFieldsQuery, useUpdateCandidateSummaryFieldsMutation } =
  candidateSummaryFieldsService;
